// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".22a94d9955f08ba169bb0cb3b298c881b7c4382b.chunk.js";
};